'use client'

import { type ThemeBackground, themeDivideColorMap } from '@mntn-dev/ui-theme'

import type { PropsWithChildren } from 'react'
import { Surface } from '../surface/surface.tsx'

type FeedItemListProps = PropsWithChildren<{
  backgroundColor?: ThemeBackground
}>

const FeedItemList = ({
  backgroundColor = 'container-secondary',
  children,
}: FeedItemListProps) => (
  <Surface border backgroundColor={backgroundColor}>
    <ul className={`flex flex-col divide-y ${themeDivideColorMap.muted}`}>
      {children}
    </ul>
  </Surface>
)

export { FeedItemList, type FeedItemListProps }
